import React from "react";
import Comingsoonpage from "../../../common/Comingsoon";

const Ar = () => {
  return (
    <div>
      <Comingsoonpage />
    </div>
  );
};

export default Ar;
